// This app's runtime config shape. The loading mechanics — fetch, the config.local.json override, and
// required-field validation — live in the shared @optimyl/config package; only the shape and the list of
// fields this app cannot start without belong here.
//
// The export surface is deliberately unchanged (`AppConfig`, `loadConfig`, `getConfig`), so every existing
// `../config` import keeps working.

import { loadConfig as load, getConfig as get, type CoreConfig } from "@optimyl/config";

export interface AppConfig extends CoreConfig {
  /**
   * Required here, optional in CoreConfig: this app has a local-dev mode that runs without Identity, and
   * every guard, the api client and the SignalR hook branch on it. The CRM app always authenticates and
   * does not carry the key.
   */
  AUTH_ENABLED: boolean;
  ENTRA_TENANT_ID: string;
  ENTRA_CLIENT_ID: string;
  ENTRA_API_SCOPE: string;
  /** Base URL of the blob assets container (logos, downloadable templates). Differs per environment. */
  ASSETS_BASE_URL: string;
  USE_MOCKS: boolean;
  API_KEY: string;
  /** Show environment picker page (test deployments only). */
  SHOW_ENV_PICKER: boolean;
  /** Available SF environments for the picker (e.g., ["dev9", "qa2"]). */
  AVAILABLE_SF_ENVIRONMENTS: string[];
  /** Renders the DevToolsPanel floating bubble for local testing. Ships false in prod. */
  SHOW_DEV_TOOLS: boolean;
}

/** Matches what this app's own validation required before the loader was shared. */
export const loadConfig = (): Promise<AppConfig> =>
  load<AppConfig>({ require: ["API_BASE_URL", "ASSETS_BASE_URL"] });

export const getConfig = (): AppConfig => get<AppConfig>();
